const PENDING_STATUSES = ['processing', 'pre-queued', 'queued'];

interface ClipStatusLike {
  clipping_status?: string | null;
  preparing_status?: string | null;
  rendering_status?: string | null;
}

/**
 * Whether a clip card offers "Carrossel de frases". A render is NOT
 * required: frames come from the project's/library's source video, so only
 * expired clips and clips still being cut/prepared (or that failed to) are
 * excluded. Rendering pending/failed/skipped does not matter.
 */
export function canMakeQuoteCarousel(clip: ClipStatusLike): boolean {
  const statuses = [clip.clipping_status, clip.preparing_status, clip.rendering_status];
  if (statuses.includes('expired')) return false;
  for (const status of [clip.clipping_status, clip.preparing_status]) {
    if (status === 'failure' || (status && PENDING_STATUSES.includes(status))) return false;
  }
  return true;
}
